import Spacer from '@berlitz/spacer'
import Select from '@components/Select'
import { languagesDropdown } from '@utils/helpers/languages'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { SelectorWrapper } from './style'

export interface LanguageSelectorProps {
  defaultVal?: string
  disabled?: boolean
  onChange?: (value?: string) => void
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ defaultVal, disabled, onChange = () => {} }) => {
  const languages = languagesDropdown()

  return (
    <SelectorWrapper>
      <span>
        <FormattedMessage id="Certificate language" />
      </span>
      <Spacer size="xxs" />
      <div>
        <Select
          disabled={disabled}
          fullWidth
          options={languages}
          defaultValue={defaultVal}
          name="CertificateLang"
          onChange={onChange}
        />
      </div>
    </SelectorWrapper>
  )
}

export default LanguageSelector
